import {
  Box,
  Button,
  Dialog,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "../Icons/circleClose.svg";
import { ReactComponent as CheckIcon } from "../Icons/CheckIcon.svg";
import { ReactComponent as SearchIcon } from "../Icons/Search.svg";
import { StyledOutlinedInput, TypographyDefault } from "../Theme";
import axiosInstance from "../AxiosInstance";

const RelocateDialogComponent = ({
  open,
  onClose,
  onSubmit,
  setSelectedCompany,
  selectedCompany,
  selectedCompanyId,
  selectedCompanyName,
}) => {
  const [selected, setSelected] = useState();
  const [relocatableCompaniesList, setRelocatableCompaniesList] = useState([]);
  const [projectsActive, setProjectsActive] = useState([]);
  const items = [
    "JLL Property Thailand",
    "Capital Land Group",
    "Ho Bee Land",
    "Far East Organization",
  ];

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}company/relocatable-companies/${selectedCompanyId}`
      )
      .then((res) => {
        setRelocatableCompaniesList(res?.data?.data?.companies);
        setProjectsActive(res?.data?.data?.projects);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedCompanyId]);

  const handleSelect = (id) => {
    setSelected(id);
    setSelectedCompany(
      relocatableCompaniesList.find((item) => item?.id === id)
    );
  };
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "580px",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar for WebKit browsers
          },
          "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
          "scrollbar-width": "none", // Hide scrollbar for Firefox
          borderRadius: " 8px",
        }, // Set width and prevent horizontal overflow
      }}
      open={open}
      onClose={onClose}
    >
      <Stack width="100%">
        <Box
          pt="16px"
          px="16px"
          pb="16px"
          display="flex"
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ borderBottom: "0.5px solid #E5E5E5" }}
        >
          <TypographyDefault
            sx={{ fontSize: "18px !important", fontWeight: "600 !important" }}
          >
            Relocate projects
          </TypographyDefault>
          <img
            src={CloseIcon}
            alt="Custom Icon"
            style={{
              cursor: "pointer",
            }}
            onClick={onClose}
          />
        </Box>
        <Stack
          gap="10px"
          px="24px"
          py="16px"
          sx={{ borderBottom: "0.5px solid #E5E5E5" }}
        >
          <TypographyDefault
            sx={{ fontSize: "16px !important", fontWeight: "600 !important" }}
          >
            Projects in {selectedCompanyName}:
          </TypographyDefault>
          <TypographyDefault
            sx={{
              color: "#1F2A37 !important",
              fontSize: "16px !important",
              fontWeight: "400 !important",
            }}
          >
            {projectsActive?.map((val) => val?.title).join(", ")}
          </TypographyDefault>
        </Stack>
        {/* <Stack gap="16px"  py="16px"> */}
        <Stack py="16px" px="24px" gap="20px">
          <TypographyDefault
            sx={{ fontSize: "16px !important", fontWeight: "600 !important" }}
          >
            Relocate to:
          </TypographyDefault>
          <StyledOutlinedInput
            //   sx={{ flexGrow: 1 }}
            // onChange={(e) => setSearch(e.target.value.toLowerCase())}
            placeholder="Search"
            startAdornment={<SearchIcon style={{ paddingRight: "5px" }} />}
            sx={{
              height: "44px !important",
              py: "0px !important",
              px: "10px",
            }}
          />
          <List
            sx={{
              display: "flex",
              flexDirection: "column",

              gap: "16px", // Add gap between list items
            }}
          >
            {relocatableCompaniesList.map((item, index) => (
              <ListItem
                key={index}
                onClick={() => handleSelect(item?.id)}
                sx={{
                  display: "flex",
                  height: "44px",
                  padding: "10px 8px 10px 8px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                  borderRadius: "6px",
                  color: selected === item?.id ? "#0E4965" : "#111927",
                  backgroundColor:
                    selected === item?.id ? "#C4D6E0" : " #F3F4F6",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor:
                      selected === item?.id ? "#C4D6E0" : "#E0E0E0",
                  },
                }}
              >
                <ListItemText primary={item?.name} />
                {selected === item?.id && (
                  <ListItemIcon
                    sx={{
                      width: "auto", // Allow icon to take the necessary space without extra width
                      minWidth: "unset", // Remove the default min-width of 56px
                    }}
                  >
                    <CheckIcon />
                  </ListItemIcon>
                )}
              </ListItem>
            ))}
          </List>
        </Stack>
        {/* </Stack> */}

        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          pb="24px"
          pt="16px"
          px="24px"
          sx={{ borderTop: "0.5px solid #E5E5E5" }}
        >
          <Button variant="white" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onSubmit();
            }}
            disabled={!selectedCompany}
            sx={
              !selectedCompany && {
                backgroundColor: "#E5E7EB !important",
                color: "#FFF !important",
              }
            }
            variant="contained"
          >
            Relocate
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default RelocateDialogComponent;
